import Header from "@/shared/components/Header";
import Footer from "@/shared/components/Footer";
import Image from "@/shared/components/Image/new";
import { useState, useEffect } from "react";
import Templates from '@/widgets/index';
import styles from "./styles.module.css";
import getDataLayer from "@/shared/functions/gtm";
import TagManager from "react-gtm-module";
import Head from "next/head";
import BannerCaja from '@/widgets/Banner/Templates/BannerCaja';
import ContenedorTitulo from "@/shared/components/ContenedorTitulo";
import { useAppContext } from '@pagegrowler_nextjs';
import MetaTags from "@/shared/components/MetaTags";
import { getWidgetsList } from "@/shared/functions/widgets";
import Chartbeat from "@/shared/components/Chartbeat";
import TituloTag from "./TituloTag";
import PagegrowlerList from "@/widgets/Listado/Templates/PagegrowlerList";

function Tag(props) {

    // estado booleano, para determinar si la data que se le envia a NotaDeSeccion, viene del servidor o del cliente
	const [conditionDataRender, setConditionDataRender] = useState(false);

    const LOAD_MORE = 10;

    const pg = useAppContext();
    const Pagegrowler = pg.pagegrowler;

    const [open, setOpen] = useState(false);
    let [data, setData] = useState([]);
    let [offset, setOffset] = useState(0);

    const [isLoading, setIsLoading] = useState(false);
    const [hideLoadMore, setHideLoadMore] = useState(false);
    const [components, setComponents] = useState();
    const [widgetsBottom, setWidgetsBottom] = useState();

    let menues = props.menu ? props.menu : [];

    const CLIPPING = "3_2_300x200";

    // Funcion que regresa las propiedades de properties vacias o no, dependiendo de la existencia de properties.
  const handleValueProperties = () => {
    const valueDefaultProperties = {
      biography: "",
      category: "",
      email: "",
      gtmPublishedDate: "",
      hasVisiblePage: "",
      idImage: "",
      imageID: "",
      imageUrl: "",
      lastModified: "",
      modificatedAt: "",
      name: "",
      product: "",
      publishedDate: "",
      shortBiography: "",
      slug: "",
      twitter: "",
      type: "",
      _id: ""
  }

  const { properties } = { ...props }

  if (properties === undefined) {
    return valueDefaultProperties
  }

  return properties
}

const propertiesValue = handleValueProperties();

    const {
        content,
        pagination = {},
        widgets
    } = { ...props };

    const description = `Noticias de ${propertiesValue.name} - Últimas noticias de ${propertiesValue.name} - El Litoral`;


    const gtmObject = {
        _id: propertiesValue._id,
        publishedDate: propertiesValue.publishedDate,
        page_type: "sección",
        nsSite: propertiesValue.nsSite,
        gtm_name: propertiesValue.name,
    };

    async function showMoreData() {
        setIsLoading(true);
        let res = await Pagegrowler.loadMoreData(LOAD_MORE, offset);
        if (res.content && res.content.length > 0) {
            setConditionDataRender(true);
            setData(prevState => [...prevState, ...res.content]);
            setOffset(offset + LOAD_MORE);
            setIsLoading(false);
        } else {
            setHideLoadMore(true);
        }
    }

    useEffect(() => {
        TagManager.dataLayer(getDataLayer(gtmObject));
        setOffset(pagination.limit + pagination.offset);
        setData(content);
        setComponents(props.widgets.filter(widget => widget.position == 'right'))
        setWidgetsBottom(props.widgets.filter(widget => widget.position == 'bottom'))
    }, []);

    let dataLDJson = {
        "@context": "https://schema.org",
        "@type": "Organization",
        "name": "Diario El Litoral",
        "url": "https://www.ellitoral.com",
        "logo": {
            "@type": "ImageObject",
            "url": `${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/header_logoellitoral.svg`,
            "width": 439,
            "height": 60
        },
        "sameAs": ["https://www.facebook.com/ellitoralcom", "https://instagram.com/ellitoral", "https://twitter.com/ellitoral", "https://plus.google.com/+EllitoralArgentina"]
    };

    function getUrl() {
        return Pagegrowler.query.match.join("/");
    }

    return (
        <>
            <Head>
                <title>{`Noticias de ${propertiesValue.name} - Últimas Noticias     : : El Litoral - Noticias - Santa Fe - Argentina - ellitoral.com : : `}</title>
                <meta name="description" property="description" content={description} />
                <meta name="author" content="Ellitoral.com" />
                <meta name="title" content={`Noticias de ${propertiesValue.name} - Últimas Noticias     : : El Litoral - Noticias - Santa Fe - Argentina - ellitoral.com : : `} />
                <meta name="og:image" property="og:image" content={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
                <meta httpEquiv="refresh" content="600" />
                <meta name="og:url" property="og:url" content={process.env.NEXT_PUBLIC_DOMAIN_URL+'/temas/'+ propertiesValue.slug} />
                <meta name="og:title" property="og:title" content={propertiesValue.name} />
                <meta name="og:type" property="og:type" content="website" />
                <meta name="og:description" property="og:description" content={description} />

                <link rel="canonical" href={process.env.NEXT_PUBLIC_DOMAIN_URL + `/${getUrl()}` } />
                <link rel="image_src" href={`${process.env.NEXT_PUBLIC_DOMAIN_URL}/img/img-default-share.jpeg`} />
                <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(dataLDJson) }} />
                <MetaTags metas={props.meta} />
            </Head>
            <Chartbeat />
            <Header menues={menues} isOpenSidePanel={(open) => setOpen(open)} />
            <div className={`${styles["parent"]}`}>
                <div className={`${styles["main-container"]}`}>
                    {!props.preview && <Templates.BannerHorizontalChico bannerId={`top`} />}
                    <TituloTag {...propertiesValue}/>
                    <div className={`${styles["grid-container"]}`}>
                        <div className={`${styles["detail-left"]}`}>
                            {data && (
                                <>
                                    <div className={`${styles["temas-container"]}`}>
                                        {(conditionDataRender ? data : content).map((element, id) => {
                                            return (
                                                <a href={element.url} key={id}>
                                                    <div className={`${styles["temas-item"]}`}>
                                                        <Image
                                                            element={element}
                                                            clipping={CLIPPING}
                                                            priority={id === 0}
                                                        />
                                                        <div className={`${styles["temas-item-txt"]}`}>
                                                            <h5>{element.subtitle}</h5>
                                                            <h1>{element.title}</h1>
                                                        </div>
                                                    </div>
                                                </a>)
                                        })}
                                    </div>
                                    <div className={styles["btn-container"]}>
                                        <button className={`${styles["btn"]} ${styles[hideLoadMore ? 'hide' : '']}`} disabled={isLoading} onClick={showMoreData}>
                                            Cargar más notas
                                        </button>
                                    </div>
                                </>
                            )}

                        </div>
                        <div className={`${styles["detail-right"]}`}>
                            <PagegrowlerList url='column-lilanews'/>
                        </div>
                    </div>

                    {!props.preview &&
                        <div className={styles["container-bannerHorizontal"]}>
                            <Templates.BannerHorizontalChico bannerId={`horizontal1`} />
                        </div>
                    }

                    <div className={`${styles["detail-full"]} tags-list`}>

                        <div className={`${styles['widget-block']}`}>
                            {widgetsBottom && (
                                widgetsBottom.map((component, index) => {
                                    if (component.position === 'bottom' && component.name === 'TePuedeInteresar') {
                                        const TargetComponent = Templates['TePuedeInteresar']
                                        const data = component
                                        return <TargetComponent {...data} key={index} limitMd={3} limitSm={2} />
                                    }
                                })
                            )}
                        </div>

                        <div className={`${styles['widget-block']}`}>
                            <div className={`${styles['column-widget-container-parent']}`}>
                                {widgetsBottom && (
                                    widgetsBottom.map((component, index) => {
                                        if (component.position === 'bottom' && component.name === 'UltimasDeSecciones') {
                                            const TargetComponent = Templates['UltimasDeSecciones']
                                            const data = component
                                            return <TargetComponent {...data} key={index} />
                                        }
                                    })
                                )}
                            </div>
                        </div>

                    </div>
                </div>
                
                {!props.preview &&
                    <div className={styles["container-bannerHorizontal"]}>
                        <Templates.BannerHorizontalGrande bannerId={`horizontal2`} />
                    </div>
                }

                <div style={{ clear: "both" }}>
                    <Footer />
                </div>
            </div>
        </>
    );
}

export default Tag;
